import * as _ from "lodash";
import * as moment from "moment";
import angular = require("angular");
import { Locality } from "@services/cmodel.repo";
import { AttributionRepo } from "@services/attribution.repo";
import { AssetClassNames } from "@common/enums/AssetClassType";
import { PortfolioRepo } from "@services/portfolio.repo";
import { AggregatePortfolioItem } from "@models/portfolio/aggregatePortfolioItem";
import { ClientRepo } from "@services/clients/client.repo";
class AttributionController implements angular.IOnInit {
    //Props passed to component
    public selectedPortfolioIds: Array<number>;
    public selectedCurrency: string;
    public clientPortfolios: any;
    public client: any;

    //Declared instance members
    public today;
    public isLoading: boolean = false;
    public quarterDates;
    public portfolioValuationSummary: AggregatePortfolioItem[];
    public securityValuationSummary: any[]; //All securities across every asset class excluding CASH
    public cashValuationSummary: any[]; //All Cash Accounts for the selected portfolios
    public totalPortfolioValuation: number = 0; //The total value of the combined portfolio
    public previousQuarterTotalPortfolioValuation: number = 0; //The total value of the combined portfolio for the previous quarter
    public totalCashValuation: number = 0; //Total CASH value
    public attributionCurrency: string = "MUR" //Portfolio Attribution is ALWAYS in MUR


    /** @ngInject */
    constructor(
      private attributionRepo: AttributionRepo,
      private portfolioRepo: PortfolioRepo,
      private $mdDialog: angular.material.IDialogService,
      private $rootScope: angular.IRootScopeService,
      private clientRepo: ClientRepo
    ) {
      this.today = moment();
    }

    $onInit() {
      this.getQuarterDates()
    }

    private getPortfolioValuationSummary() {
      this.portfolioRepo
          .getPortfolioAggregatesByAssetClasses(null, this.attributionCurrency, null, this.selectedPortfolioIds, this.quarterDates.currentQuarter.endDate)
          .then(res => {
              this.portfolioValuationSummary = res
              this.totalPortfolioValuation = _.sumBy(this.portfolioValuationSummary, x => x.total);
              this.totalCashValuation = this.portfolioValuationSummary.find(x => x.name === "Cash").total
          })
          .catch(e => console.log(e))
          .finally(() => {
            if(this.allDataReturned()) {
              this.isLoading = false
            }
          })
    }
    
    private getPreviousQuarterPortfolioValuationSummary() {
      this.portfolioRepo
          .getPortfolioAggregatesByAssetClasses(null, this.attributionCurrency, null, this.selectedPortfolioIds, this.quarterDates.previousQuarter.endDate)
          .then(res => {
              this.previousQuarterTotalPortfolioValuation = _.sumBy(res, x => x.total)
          })
          .catch(e => console.log(e))
          .finally(() => {
            if(this.allDataReturned()) {
              this.isLoading = false
            }
          })
    }

    private getSecurityValuationSummary() {
      this.attributionRepo
      .getSecurityValuationSummary(this.attributionCurrency, this.selectedPortfolioIds, this.quarterDates.currentQuarter.endDate)
      .then(res => {
          this.securityValuationSummary = res.data as any[]
      })
      .catch(e => console.log(e))
      .finally(() => {
        if(this.allDataReturned()) {
          this.isLoading = false
        }
      })
    }

    private getCashValuationSummary() {
      this.attributionRepo
        .getCashValuationSummary(this.attributionCurrency, this.selectedPortfolioIds, this.quarterDates.currentQuarter.endDate)
        .then(res => {
            this.cashValuationSummary = res.data as any[]
            this.cashValuationSummary = this.cashValuationSummary.filter(cv => cv.marketValue > 0)
        })
        .catch(e => console.log(e))
        .finally(() => {
          if(this.allDataReturned()) {
            this.isLoading = false
          }
        })
    }

    private getQuarterDates() {
      this.isLoading = true
      this.attributionRepo
        .getQuarterDates(this.today.format("YYYY-MM-DD"))
        .then(res => {
            this.quarterDates = res.data as any
            this.getPortfolioValuationSummary()
            this.getPreviousQuarterPortfolioValuationSummary()
            this.getSecurityValuationSummary()
            this.getCashValuationSummary()
        })
        .catch(e => console.log(e))
        .finally(() => {
          if(this.allDataReturned()) {
            this.isLoading = false
          }
        })
    }

    getClientDetails() {
      this.isLoading = true
      this.clientRepo.getClient(this.client.clientNumber)
      .then(res => {
        this.client = res.data
      })
      .catch(exc => console.log(exc))
      .finally(() => {
        this.isLoading = false
      })
    }

    getValuationsByAssetClassName(assetClass: string) {
      return this.securityValuationSummary.filter(s => s.assetClass === assetClass)
    }

    public getFixedIncomeValuations() {
      return this.securityValuationSummary.filter(s => s.assetClass === AssetClassNames.FIXED_INCOME)
    }

    public getEquityValuations() {
      return this.securityValuationSummary.filter(s => s.assetClass === AssetClassNames.EQUITY)
    }

    public getAlternativeInValuations() {
      return this.securityValuationSummary.filter(s => s.assetClass === AssetClassNames.ALTERNATIVE_INV)
    }

    public getPreciousMetalsValuations() {
      return this.securityValuationSummary.filter(s => s.assetClass === AssetClassNames.PRECIOUS_METALS)
    }

    public getCashAccountValuations() {
      return this.cashValuationSummary
    }

    public formatLocality(security: any) {
      return (security.locality as Locality) === Locality.Local ? 'Mauritius' : 'International'
    }

    public getSecurityWeighting(amount: number) {
      return (amount/this.totalPortfolioValuation) * 100
    }

    public getQTQWeighting(amount: number, netCashFlow: number) {
      return (amount/(this.previousQuarterTotalPortfolioValuation + (this.client.dietz * netCashFlow))) * 100
    }

    public allDataReturned() {
      return this.portfolioValuationSummary && this.securityValuationSummary && this.cashValuationSummary && this.cashValuationSummary && this.quarterDates && this.previousQuarterTotalPortfolioValuation
    }

    public displayCashTransactions(security) {
      /**@property showTransactions does not exist on the response from the API,
       * We are leveraging js functionality to add and initialise it dynamically
       */
      security.showTransactions = !security.showTransactions
    }

    public openDietzDialog() {
      const client = this.client
      const tempScope = this.$rootScope.$new(true) as any;
      tempScope.client = client;
      
      this.$mdDialog
      .show({
        template: `<modify-dietz-dialog client="client"></cash-transaction-dialog>`,
        clickOutsideToClose: true,
        scope: tempScope,
      })
      .then((result) => {
        if (result) {
          this.getClientDetails()
        }
      });
    }
}

export const attribution: angular.IComponentOptions = {
  template: require("./attribution.html"),
  controller: AttributionController,
  bindings: {
    selectedPortfolioIds: "<",
    selectedCurrency: "<",
    clientPortfolios: "<",
    client: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/attribution/attribution.ts